















































import { Component, Mixins } from "vue-property-decorator";
import { ActionTypes } from "@/data/enums";
import { ISegmentTypes } from "@/data/enums/segments";
import AdminBrandId from "@/mixins/adminBrandId";
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "segments-provider": () =>
      import("@/components/app/admin/segments/segmentsProvider.vue"),
    "segments-list-view": () =>
      import("@/components/app/admin/segments/segmentsListView.vue")
  }
})
export default class AdminClientsListView extends Mixins(AdminBrandId) {
  // Data
  public segmentType = ISegmentTypes.CLIENT;

  // Computed
  public get canCreateSegment() {
    return this.$userCan("create_segment");
  }

  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all_clients"),
        to: {
          name: "adminClients_all"
        }
      },
      {
        label: this.$t("_.all_clients_excluding_guests"),
        to: {
          name: "adminClients_excludingGuests"
        }
      },
      {
        label: this.$t("_.unverified_clients"),
        to: {
          name: "adminClients_unverified"
        }
      },
      {
        label: this.$t("_.clients_from_last_30_days"),
        to: {
          name: "adminClients_last30Days"
        }
      },
      {
        label: this.$t("_.pending_review"),
        to: {
          name: "adminClients_pendingReview"
        }
      },
      {
        label: this.$t("_.blocked"),
        to: {
          name: "adminClients_blocked"
        }
      }
    ];
  }

  public createClientSegment(): void {
    if (!this.$userCan("create_segment")) {
      return;
    }
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import("@/components/app/admin/segments/addEditSegmentModal.vue"),
        props: {
          segmentType: this.segmentType,
          newSegmentRedirectRoute: "adminClientsSegments",
          actionType: ActionTypes.CREATE
        }
      }
    });
  }
}
